import {VcParallax, VcParallaxSection} from './components/vc-parallax/index.js'

export {VcParallax, VcParallaxSection}



// WEBPACK FOOTER //
// ./src/lib.js